import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { CompatibilityResponse as Compatibility } from 'ctp-compatibility-checker';
import CompatibilityInformation from './CompatibilityInformation.vue';
import {
  compatibilityStatusColumns,
  compatibilityTableColumns,
  CompatibilityTableType
} from './tableColumns';
import './styles/compatibility-table.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompatibilityTable',
  props: {
    compatibilities: null,
    type: null
  },
  emits: ["resolveBrandModel"],
  setup(__props: any, { emit }: { emit: ({(event: 'resolveBrandModel', payload: {
    rowIndex: number;
    brand: string;
    model: string;
    compat: Compatibility;
    tableType: CompatibilityTableType;
  }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  compatibilities: Compatibility[];
  type: CompatibilityTableType;
};





const handleResolveBrandModel = (payload: {
  rowIndex: number;
  brand: string;
  model: string;
  compat: Compatibility;
}) => {
  emit('resolveBrandModel', { ...payload, tableType: props.type });
};

const columns = computed(() => compatibilityTableColumns[props.type]);
const statusColumns = compatibilityStatusColumns;
const gridStyle = computed(() => ({
  gridTemplateColumns: `repeat(${columns.value.length}, minmax(110px, 1fr))`
}));
const tableStyle = computed(() => ({ minWidth: `${columns.value.length * 140}px` }));

return { __sfc: true,props, emit, handleResolveBrandModel, columns, statusColumns, gridStyle, tableStyle, CompatibilityInformation }
}

})